module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', [(_vm.cityAdmin) ? _c('div', [_c('div', {
    class: _vm.addButtonClass
  }, [_c('div', {
    staticClass: "monitoring-link"
  }, [(_vm.traccarUrl == '' || _vm.traccarUrl == null) ? _c('a', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "non-clickable",
    attrs: {
      "disabled": "",
      "title": "Data not found"
    }
  }, [_vm._v("Vehicle Monitoring")]) : _vm._e(), _vm._v(" "), (_vm.traccarUrl) ? _c('a', {
    attrs: {
      "href": _vm.traccarUrl,
      "target": "_blank"
    }
  }, [_vm._v("Vehicle Monitoring")]) : _vm._e()])]), _vm._v(" "), _c('v-server-table', {
    ref: "vehicleTripTable",
    attrs: {
      "url": "",
      "limit": 5,
      "columns": _vm.columns,
      "options": _vm.options
    },
    on: {
      "loaded": _vm.onLoaded
    },
    scopedSlots: _vm._u([{
      key: "action",
      fn: function(props) {
        return [_c('div', {
          staticClass: "active_wrp"
        }, [_c('a', {
          staticClass: "fa fa-car",
          attrs: {
            "role": "button"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.action(props.row)
            }
          }
        })])]
      }
    }])
  }, [_c('template', {
    slot: "beforeBody"
  }, [(_vm.loading) ? _c('tr', {
    staticClass: "VueTables__no-results"
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "9"
    }
  }, [_c('pulse-loader')], 1)]) : _vm._e()])], 2), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 map_view_wrp newiframewrp"
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.cityAdmin) ? _c('div', {
    staticClass: "monitoring-link",
    staticStyle: {
      "justify-content": "center"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://tracker.goaheadtechnologies.in/",
      "target": "_blank"
    }
  }, [_vm._v("Click here to login to Traccar")])]) : _vm._e()])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1a1145f4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a1145f4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/location-tracking/vehicleTracking.vue
// module id = 2268
// module chunks = 0